/* eslint-disable no-console */
/**
 * Запрос подсказок
 */
export function getSuggestions(
	query,
	{
		connectionString,
		token,
		fromBound,
		toBound,
		searchIntercept,
		addressFormatter,
		count,
		parts,
	}
) {
	if (!token) {
		console.error('Не передан токен DaData');
	}

	if (!connectionString) {
		console.error('Не передана строка подключения');
	}

	const xhr = new XMLHttpRequest();
	const requestId = Math.random();
	xhr.open("POST", connectionString);
	xhr.setRequestHeader("Accept", "application/json");
	xhr.setRequestHeader("Authorization", `Token ${token}`);
	xhr.setRequestHeader("Content-Type", "application/json");
	const requestPayload = {
		query: query,
		count: count,
		parts: parts,
	};

	// Если показываем только определенную часть адреса
	if (fromBound && toBound) {
		requestPayload.from_bound = {value: fromBound};
		requestPayload.to_bound = {value: toBound};
		requestPayload.restrict_value = true;
	}

	// Если в пропсы передали функцию перехватчик для строки поиска, то выполняем её
	if (searchIntercept !== null) {
		requestPayload.query = searchIntercept(requestPayload.query);
	}

	xhr.send(JSON.stringify(requestPayload));

	let resolveRequest, rejectRequest;
	const promise = new Promise(function (resolve, reject) {
		resolveRequest = resolve;
		rejectRequest = reject;
	});

	xhr.onreadystatechange = () => {
		if (!xhr || xhr.readyState !== 4) {
			return;
		}

		if (xhr.status === 200) {
			const responseJson = JSON.parse(xhr.response);

			let suggestions = [];
			if (responseJson && responseJson.suggestions) {
				suggestions = addressFormatter
					? addressFormatter(responseJson.suggestions)
					: responseJson.suggestions;
			}
			resolveRequest({suggestions, requestId});
		} else {
			rejectRequest(xhr.status);
		}
	};

	return {
		request: {
			id: requestId,
			abort: () => xhr.abort(),
		},
		promise,
	};
}


export function defaultAddressFormatter(suggestions) {
	return suggestions
		.filter(suggestion => {
			return suggestion.data.street_with_type !== null
				&& suggestion.data.house_type !== null
				&& suggestion.data.house !== null;
		})
		.map(suggestion => {
			suggestion.unrestricted_value =
				`${suggestion.data.street_with_type}, ${
					suggestion.data.house_type} ${
					suggestion.data.house} ${
					suggestion.data.block_type
						? suggestion.data.block_type + ' ' + suggestion.data.block
						: ''}${
					suggestion.data.flat ? `, ${
						suggestion.data.flat_type}. ${suggestion.data.flat}` : ''}`;
			return suggestion;
		});
}
